<template>
	<div ref="el" data-component="landing" data-page="index.page" data-entry-segment-preload="pending">
		<Header v-bind="getSection('header')" />

		<main>
			<Benefits v-bind="getSection('benefits')" />

			<Challenge v-bind="getSection('challenge')" />
			<Struggles v-bind="getSection('struggles')" />
			<Introduction v-bind="getSection('introduction')" />
			<Capabilities v-bind="getSection('capabilities')" />
			<Insights v-bind="getSection('insights')" />

			<Team v-bind="getSection('team')" />
			<Tagline v-bind="getSection('tagline')" />
		</main>

		<Footer v-bind="footer" />
	</div>
</template>

<script setup>
import { Header, Benefits, Team, Challenge, Struggles, Introduction, Insights, Capabilities } from './sections'
import { Footer, Tagline } from '~/components/sections'
import { createLandingMotion } from './Landing.motion.js'

const props = defineProps({
	sections: { type: Array, default: undefined },
	footer: { type: Object, default: undefined },
})

const el = ref(null)
const context = inject('pageContext')
const motion = createLandingMotion({ el, loader: context?.$page?.loader })

const getSection = (section) =>
	props.sections.find(
		(el) => (el.internalTitle && el.internalTitle.replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : '')).replace(/^(.)/, (m) => m.toLowerCase()) === section) || el._type == section
	)

onBeforeUnmount(() => {
	motion.kill()
})
onMounted(() => {
	motion.mount()
})
</script>

<style lang="scss" scoped>
[data-component='landing'] {
	position: relative;

	&[data-entry-segment-preload='pending'] {
		:deep([data-segment-order='1'] path),
		:deep([data-segment-order='2'] path),
		:deep([data-generated-segment-connectors] path[data-connector-from-order='1'][data-connector-to-order='2']) {
			opacity: 0;
		}
	}

	main {
		position: relative;
		z-index: 1;
	}
}
</style>
